// src/constants/event-types.ts
var ACTIVITY_TYPES = [
  "event",
  "course",
  "diagnostic",
  "certification",
  "project"
];
var ACTIVITY_STATUSES = [
  "registered",
  "in_progress",
  "completed",
  "cancelled",
  "failed"
];
var ACTIVITY_TYPE_LABELS_RU = {
  event: "\u041C\u0435\u0440\u043E\u043F\u0440\u0438\u044F\u0442\u0438\u0435",
  course: "\u041A\u0443\u0440\u0441",
  diagnostic: "\u0414\u0438\u0430\u0433\u043D\u043E\u0441\u0442\u0438\u043A\u0430",
  certification: "\u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F",
  project: "\u041F\u0440\u043E\u0435\u043A\u0442"
};
var ACTIVITY_STATUS_LABELS_RU = {
  registered: "\u0417\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D",
  in_progress: "\u0412 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u0435",
  completed: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E",
  cancelled: "\u041E\u0442\u043C\u0435\u043D\u0435\u043D\u043E",
  failed: "\u041D\u0435 \u043F\u0440\u043E\u0439\u0434\u0435\u043D\u043E"
};

// src/constants/event-catalog.ts
var EVENT_SOURCES = ["molfest", "inpdp", "events", "manual"];
var EVENT_LIFECYCLES = ["draft", "published", "cancelled"];
var REGISTRATION_STATUSES = [
  "registered",
  "confirmed",
  "attended",
  "cancelled",
  "waitlisted"
];
var EVENT_SOURCE_LABELS_RU = {
  molfest: "\u041C\u043E\u043B\u043E\u0434\u0451\u0436\u043D\u044B\u0439 \u0444\u0435\u0441\u0442\u0438\u0432\u0430\u043B\u044C",
  inpdp: "\u041C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u0430\u044F \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430",
  events: "\u041C\u0435\u0440\u043E\u043F\u0440\u0438\u044F\u0442\u0438\u044F ARPM",
  manual: "\u0412\u0440\u0443\u0447\u043D\u0443\u044E"
};
var REGISTRATION_STATUS_LABELS_RU = {
  registered: "\u0417\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D",
  confirmed: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u043E",
  attended: "\u041F\u043E\u0441\u0435\u0449\u0435\u043D\u043E",
  cancelled: "\u041E\u0442\u043C\u0435\u043D\u0435\u043D\u043E",
  waitlisted: "\u041B\u0438\u0441\u0442 \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F"
};

// src/constants/intranet-modules.ts
var INTRANET_MODERATABLE_MODULES = [
  { key: "documents", order: 10 },
  { key: "emergency", order: 20 },
  { key: "onboarding", order: 30 },
  { key: "vacations", order: 40 },
  { key: "projects", order: 50 },
  { key: "assignments", order: 60 }
];
var INTRANET_MODULE_KEYS = INTRANET_MODERATABLE_MODULES.map(
  (m) => m.key
);
var INTRANET_MODULE_LABELS_RU = {
  documents: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B",
  emergency: "\u041F\u0435\u0440\u0432\u0430\u044F \u043F\u043E\u043C\u043E\u0449\u044C / \u0427\u0421",
  onboarding: "\u041F\u0430\u043F\u043A\u0430 \u043D\u043E\u0432\u0438\u0447\u043A\u0430",
  vacations: "\u041E\u0442\u043F\u0443\u0441\u043A\u0430",
  projects: "\u041F\u0440\u043E\u0435\u043A\u0442\u044B",
  assignments: "\u041F\u043E\u0440\u0443\u0447\u0435\u043D\u0438\u044F"
};

// src/constants/project-colors.ts
var PROJECT_COLORS = [
  "green",
  "pink",
  "yellow",
  "blue",
  "violet",
  "orange",
  "teal",
  "gray",
  "red",
  "lime",
  "cyan",
  "indigo",
  "purple",
  "rose",
  "amber",
  "brown"
];
var HEX_COLOR_RE = /^#[0-9a-fA-F]{6}$/;
function isPersonalProjectColor(v) {
  return typeof v === "string" && (PROJECT_COLORS.includes(v) || HEX_COLOR_RE.test(v));
}

// src/constants/content.ts
var CONTENT_KINDS = ["promo", "story"];
var CONTENT_KIND_LABELS_RU = {
  promo: "\u041F\u0440\u043E\u043C\u043E",
  story: "\u0421\u0442\u043E\u0440\u0438\u0441"
};

// src/constants/services.ts
var SERVICE_CATEGORIES = [
  "general",
  "events",
  "analytics",
  "admin",
  "integration"
];
var SERVICE_CATEGORY_LABELS_RU = {
  general: "\u0411\u0430\u0437\u043E\u0432\u044B\u0435",
  events: "\u041C\u0435\u0440\u043E\u043F\u0440\u0438\u044F\u0442\u0438\u044F",
  analytics: "\u0410\u043D\u0430\u043B\u0438\u0442\u0438\u043A\u0430",
  admin: "\u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435",
  integration: "\u0418\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0438\u0438"
};
var SERVICE_VISIBILITIES = ["public", "restricted", "admin_only"];
var SERVICE_VISIBILITY_LABELS_RU = {
  public: "\u0412\u0438\u0434\u0435\u043D \u0432\u0441\u0435\u043C",
  restricted: "\u041F\u043E \u0440\u043E\u043B\u044F\u043C \u0441\u0435\u0440\u0432\u0438\u0441\u0430",
  admin_only: "\u0422\u043E\u043B\u044C\u043A\u043E \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430\u043C"
};

// src/constants/roles.ts
var LK_ADMIN_ROLE_CODE = "lk-admin";
var LK_ADMIN_ROLE_REF = { serviceCode: null, code: LK_ADMIN_ROLE_CODE };
function formatRoleRef(ref) {
  return ref.serviceCode ? `${ref.serviceCode}:${ref.code}` : ref.code;
}
function parseRoleRef(input) {
  const colon = input.indexOf(":");
  if (colon === -1) {
    return { serviceCode: null, code: input };
  }
  return {
    serviceCode: input.slice(0, colon),
    code: input.slice(colon + 1)
  };
}
var ROLE_LK_ADMIN = "lk-arpm:admin";
var ROLE_LK_USER = "lk-arpm:user";
function roleName(client, role) {
  return `${client}:${role}`;
}
function parseRoleName(input) {
  const match = /^([a-z0-9-]+):([a-z0-9-_]+)$/.exec(input);
  if (!match) {
    return null;
  }
  return { client: match[1], role: match[2] };
}

// src/constants/regions.ts
var RU_REGIONS = Object.freeze({
  "01": "\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0410\u0434\u044B\u0433\u0435\u044F",
  "02": "\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0411\u0430\u0448\u043A\u043E\u0440\u0442\u043E\u0441\u0442\u0430\u043D",
  "03": "\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0411\u0443\u0440\u044F\u0442\u0438\u044F",
  "04": "\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0410\u043B\u0442\u0430\u0439",
  "05": "\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0414\u0430\u0433\u0435\u0441\u0442\u0430\u043D",
  "06": "\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0418\u043D\u0433\u0443\u0448\u0435\u0442\u0438\u044F",
  "07": "\u041A\u0430\u0431\u0430\u0440\u0434\u0438\u043D\u043E-\u0411\u0430\u043B\u043A\u0430\u0440\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430",
  "08": "\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u0430\u043B\u043C\u044B\u043A\u0438\u044F",
  "09": "\u041A\u0430\u0440\u0430\u0447\u0430\u0435\u0432\u043E-\u0427\u0435\u0440\u043A\u0435\u0441\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430",
  "10": "\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u0430\u0440\u0435\u043B\u0438\u044F",
  "11": "\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u043E\u043C\u0438",
  "12": "\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041C\u0430\u0440\u0438\u0439 \u042D\u043B",
  "13": "\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041C\u043E\u0440\u0434\u043E\u0432\u0438\u044F",
  "14": "\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0421\u0430\u0445\u0430 (\u042F\u043A\u0443\u0442\u0438\u044F)",
  "15": "\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0421\u0435\u0432\u0435\u0440\u043D\u0430\u044F \u041E\u0441\u0435\u0442\u0438\u044F \u2014 \u0410\u043B\u0430\u043D\u0438\u044F",
  "16": "\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0422\u0430\u0442\u0430\u0440\u0441\u0442\u0430\u043D",
  "17": "\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0422\u044B\u0432\u0430",
  "18": "\u0423\u0434\u043C\u0443\u0440\u0442\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430",
  "19": "\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0425\u0430\u043A\u0430\u0441\u0438\u044F",
  "20": "\u0427\u0435\u0447\u0435\u043D\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430",
  "21": "\u0427\u0443\u0432\u0430\u0448\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430",
  "22": "\u0410\u043B\u0442\u0430\u0439\u0441\u043A\u0438\u0439 \u043A\u0440\u0430\u0439",
  "23": "\u041A\u0440\u0430\u0441\u043D\u043E\u0434\u0430\u0440\u0441\u043A\u0438\u0439 \u043A\u0440\u0430\u0439",
  "24": "\u041A\u0440\u0430\u0441\u043D\u043E\u044F\u0440\u0441\u043A\u0438\u0439 \u043A\u0440\u0430\u0439",
  "25": "\u041F\u0440\u0438\u043C\u043E\u0440\u0441\u043A\u0438\u0439 \u043A\u0440\u0430\u0439",
  "26": "\u0421\u0442\u0430\u0432\u0440\u043E\u043F\u043E\u043B\u044C\u0441\u043A\u0438\u0439 \u043A\u0440\u0430\u0439",
  "27": "\u0425\u0430\u0431\u0430\u0440\u043E\u0432\u0441\u043A\u0438\u0439 \u043A\u0440\u0430\u0439",
  "28": "\u0410\u043C\u0443\u0440\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "29": "\u0410\u0440\u0445\u0430\u043D\u0433\u0435\u043B\u044C\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "30": "\u0410\u0441\u0442\u0440\u0430\u0445\u0430\u043D\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "31": "\u0411\u0435\u043B\u0433\u043E\u0440\u043E\u0434\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "32": "\u0411\u0440\u044F\u043D\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "33": "\u0412\u043B\u0430\u0434\u0438\u043C\u0438\u0440\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "34": "\u0412\u043E\u043B\u0433\u043E\u0433\u0440\u0430\u0434\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "35": "\u0412\u043E\u043B\u043E\u0433\u043E\u0434\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "36": "\u0412\u043E\u0440\u043E\u043D\u0435\u0436\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "37": "\u0418\u0432\u0430\u043D\u043E\u0432\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "38": "\u0418\u0440\u043A\u0443\u0442\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "39": "\u041A\u0430\u043B\u0438\u043D\u0438\u043D\u0433\u0440\u0430\u0434\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "40": "\u041A\u0430\u043B\u0443\u0436\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "41": "\u041A\u0430\u043C\u0447\u0430\u0442\u0441\u043A\u0438\u0439 \u043A\u0440\u0430\u0439",
  "42": "\u041A\u0435\u043C\u0435\u0440\u043E\u0432\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C \u2014 \u041A\u0443\u0437\u0431\u0430\u0441\u0441",
  "43": "\u041A\u0438\u0440\u043E\u0432\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "44": "\u041A\u043E\u0441\u0442\u0440\u043E\u043C\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "45": "\u041A\u0443\u0440\u0433\u0430\u043D\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "46": "\u041A\u0443\u0440\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "47": "\u041B\u0435\u043D\u0438\u043D\u0433\u0440\u0430\u0434\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "48": "\u041B\u0438\u043F\u0435\u0446\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "49": "\u041C\u0430\u0433\u0430\u0434\u0430\u043D\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "50": "\u041C\u043E\u0441\u043A\u043E\u0432\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "51": "\u041C\u0443\u0440\u043C\u0430\u043D\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "52": "\u041D\u0438\u0436\u0435\u0433\u043E\u0440\u043E\u0434\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "53": "\u041D\u043E\u0432\u0433\u043E\u0440\u043E\u0434\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "54": "\u041D\u043E\u0432\u043E\u0441\u0438\u0431\u0438\u0440\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "55": "\u041E\u043C\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "56": "\u041E\u0440\u0435\u043D\u0431\u0443\u0440\u0433\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "57": "\u041E\u0440\u043B\u043E\u0432\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "58": "\u041F\u0435\u043D\u0437\u0435\u043D\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "59": "\u041F\u0435\u0440\u043C\u0441\u043A\u0438\u0439 \u043A\u0440\u0430\u0439",
  "60": "\u041F\u0441\u043A\u043E\u0432\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "61": "\u0420\u043E\u0441\u0442\u043E\u0432\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "62": "\u0420\u044F\u0437\u0430\u043D\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "63": "\u0421\u0430\u043C\u0430\u0440\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "64": "\u0421\u0430\u0440\u0430\u0442\u043E\u0432\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "65": "\u0421\u0430\u0445\u0430\u043B\u0438\u043D\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "66": "\u0421\u0432\u0435\u0440\u0434\u043B\u043E\u0432\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "67": "\u0421\u043C\u043E\u043B\u0435\u043D\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "68": "\u0422\u0430\u043C\u0431\u043E\u0432\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "69": "\u0422\u0432\u0435\u0440\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "70": "\u0422\u043E\u043C\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "71": "\u0422\u0443\u043B\u044C\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "72": "\u0422\u044E\u043C\u0435\u043D\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "73": "\u0423\u043B\u044C\u044F\u043D\u043E\u0432\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "74": "\u0427\u0435\u043B\u044F\u0431\u0438\u043D\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "75": "\u0417\u0430\u0431\u0430\u0439\u043A\u0430\u043B\u044C\u0441\u043A\u0438\u0439 \u043A\u0440\u0430\u0439",
  "76": "\u042F\u0440\u043E\u0441\u043B\u0430\u0432\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "77": "\u041C\u043E\u0441\u043A\u0432\u0430",
  "78": "\u0421\u0430\u043D\u043A\u0442-\u041F\u0435\u0442\u0435\u0440\u0431\u0443\u0440\u0433",
  "79": "\u0415\u0432\u0440\u0435\u0439\u0441\u043A\u0430\u044F \u0430\u0432\u0442\u043E\u043D\u043E\u043C\u043D\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "80": "\u041D\u0435\u043D\u0435\u0446\u043A\u0438\u0439 \u0430\u0432\u0442\u043E\u043D\u043E\u043C\u043D\u044B\u0439 \u043E\u043A\u0440\u0443\u0433",
  "81": "\u0425\u0430\u043D\u0442\u044B-\u041C\u0430\u043D\u0441\u0438\u0439\u0441\u043A\u0438\u0439 \u0430\u0432\u0442\u043E\u043D\u043E\u043C\u043D\u044B\u0439 \u043E\u043A\u0440\u0443\u0433 \u2014 \u042E\u0433\u0440\u0430",
  "82": "\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u0440\u044B\u043C",
  "83": "\u0427\u0443\u043A\u043E\u0442\u0441\u043A\u0438\u0439 \u0430\u0432\u0442\u043E\u043D\u043E\u043C\u043D\u044B\u0439 \u043E\u043A\u0440\u0443\u0433",
  "84": "\u042F\u043C\u0430\u043B\u043E-\u041D\u0435\u043D\u0435\u0446\u043A\u0438\u0439 \u0430\u0432\u0442\u043E\u043D\u043E\u043C\u043D\u044B\u0439 \u043E\u043A\u0440\u0443\u0433",
  "85": "\u0421\u0435\u0432\u0430\u0441\u0442\u043E\u043F\u043E\u043B\u044C",
  "86": "\u0414\u043E\u043D\u0435\u0446\u043A\u0430\u044F \u041D\u0430\u0440\u043E\u0434\u043D\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430",
  "87": "\u041B\u0443\u0433\u0430\u043D\u0441\u043A\u0430\u044F \u041D\u0430\u0440\u043E\u0434\u043D\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430",
  "88": "\u0417\u0430\u043F\u043E\u0440\u043E\u0436\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "89": "\u0425\u0435\u0440\u0441\u043E\u043D\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
  "99": "\u0411\u0430\u0439\u043A\u043E\u043D\u0443\u0440"
});
function regionTitle(code) {
  if (!code) return null;
  return RU_REGIONS[code] ?? code;
}
function countryTitle(code, locale = "ru") {
  if (!code) return null;
  try {
    return new Intl.DisplayNames([locale], { type: "region" }).of(code.toUpperCase()) ?? code;
  } catch {
    return code;
  }
}

// src/constants/reminders.ts
var REMIND_DAYS_OPTIONS = [0, 1, 2, 3, 5, 7];
var DEFAULT_REMIND_DAYS = 3;

// src/constants/file-preview.ts
var BY_EXT = {
  png: { kind: "image", mime: "image/png" },
  jpg: { kind: "image", mime: "image/jpeg" },
  jpeg: { kind: "image", mime: "image/jpeg" },
  gif: { kind: "image", mime: "image/gif" },
  webp: { kind: "image", mime: "image/webp" },
  pdf: { kind: "pdf", mime: "application/pdf" },
  txt: { kind: "text", mime: "text/plain; charset=utf-8" },
  // Офисные документы показываются как PDF, который сервер собирает LibreOffice
  // (если он установлен); mime — тип того, что уходит в окно просмотра.
  doc: { kind: "office", mime: "application/pdf" },
  docx: { kind: "office", mime: "application/pdf" },
  odt: { kind: "office", mime: "application/pdf" },
  rtf: { kind: "office", mime: "application/pdf" },
  xls: { kind: "office", mime: "application/pdf" },
  xlsx: { kind: "office", mime: "application/pdf" },
  ods: { kind: "office", mime: "application/pdf" },
  ppt: { kind: "office", mime: "application/pdf" },
  pptx: { kind: "office", mime: "application/pdf" },
  odp: { kind: "office", mime: "application/pdf" }
};
function filePreview(fileName) {
  const ext = fileName.toLowerCase().split(".").pop() ?? "";
  return BY_EXT[ext] ?? null;
}

// src/constants/form-field-keys.ts
var FORM_FIELD_KEY_PATTERN = /^[a-z0-9_]+$/;
var FORM_FIELD_KEY_MAX = 64;
var WORK_REGION_ABROAD = "ABROAD";
var ISO_COUNTRY_CODES = Object.freeze(
  "AD AE AF AG AI AL AM AO AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GT GU GW GY HK HN HR HT HU ID IE IL IM IN IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG US UY UZ VA VC VE VG VI VN VU WF WS YE YT ZA ZM ZW".split(" ")
);
function countryOptions(locale = "ru") {
  const names = new Intl.DisplayNames([locale], { type: "region" });
  const ru = new Intl.DisplayNames(["ru"], { type: "region" });
  return ISO_COUNTRY_CODES.map((code) => ({
    value: code,
    label: names.of(code) ?? code,
    sortKey: ru.of(code) ?? code
  })).sort(
    (a, b) => a.value === "RU" ? -1 : b.value === "RU" ? 1 : a.sortKey.localeCompare(b.sortKey, "ru")
  ).map(({ value, label }) => ({ value, label }));
}
function workRegionOptions(locale = "ru") {
  const regions = Object.entries(RU_REGIONS).map(([value, label]) => ({ value, label })).sort((a, b) => a.label.localeCompare(b.label, "ru"));
  return [
    ...regions,
    { value: WORK_REGION_ABROAD, label: locale === "en" ? "Outside Russia" : "\u0417\u0430 \u043F\u0440\u0435\u0434\u0435\u043B\u0430\u043C\u0438 \u0420\u0424" }
  ];
}
var SYSTEM_FIELD_KEYS = Object.freeze([
  {
    key: "country",
    label: "\u0421\u0442\u0440\u0430\u043D\u0430",
    labelEn: "Country",
    help: "\u0421\u0442\u0440\u0430\u043D\u0430, \u0438\u0437 \u043A\u043E\u0442\u043E\u0440\u043E\u0439 \u0432\u044B \u043F\u0440\u0438\u0435\u0445\u0430\u043B\u0438",
    helpEn: "The country you come from",
    type: "select",
    purpose: "\u0440\u0430\u0437\u0440\u0435\u0437 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u043E\u0432 \u043F\u043E \u0441\u0442\u0440\u0430\u043D\u0430\u043C \u0438 \u043A\u043E\u043B\u043E\u043D\u043A\u0430 \xAB\u0421\u0442\u0440\u0430\u043D\u0430\xBB \u0432 \u0448\u0430\u0431\u043B\u043E\u043D\u0435 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430",
    labelPatterns: [/^\s*стран[аы](?!\p{L})/iu, /^\s*country(?!\p{L})/iu],
    options: countryOptions
  },
  {
    key: "work_region",
    label: "\u041C\u0435\u0441\u0442\u043E \u0440\u0430\u0431\u043E\u0442\u044B \u2014 \u0441\u0443\u0431\u044A\u0435\u043A\u0442 \u0420\u0424",
    labelEn: "Workplace \u2014 region of Russia",
    help: "\u0421\u0443\u0431\u044A\u0435\u043A\u0442 \u0420\u0424, \u0432 \u043A\u043E\u0442\u043E\u0440\u043E\u043C \u043D\u0430\u0445\u043E\u0434\u0438\u0442\u0441\u044F \u0432\u0430\u0448\u0435 \u043F\u0440\u0435\u0434\u043F\u0440\u0438\u044F\u0442\u0438\u0435. \u0415\u0441\u043B\u0438 \u043E\u043D\u043E \u0437\u0430 \u0440\u0443\u0431\u0435\u0436\u043E\u043C \u2014 \xAB\u0417\u0430 \u043F\u0440\u0435\u0434\u0435\u043B\u0430\u043C\u0438 \u0420\u0424\xBB",
    helpEn: "The region of Russia where your employer is located. If abroad, choose \u201COutside Russia\u201D",
    type: "select",
    purpose: "\u0440\u0430\u0437\u0440\u0435\u0437 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u043E\u0432 \u043F\u043E \u0440\u0435\u0433\u0438\u043E\u043D\u0430\u043C \u0438 \u043A\u043E\u043B\u043E\u043D\u043A\u0430 \xAB\u041C\u0435\u0441\u0442\u043E \u0440\u0430\u0431\u043E\u0442\u044B\xBB \u0432 \u0448\u0430\u0431\u043B\u043E\u043D\u0435 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430",
    // «Регион» без уточнения сюда не относится: бывает «регион делегации» —
    // это не место работы, а у поля может быть свой тип `region`.
    labelPatterns: [/субъект\p{L}*\s+(рф|российской)/iu, /work\s*region/iu],
    options: workRegionOptions
  }
]);
function systemFieldKey(key) {
  return key ? SYSTEM_FIELD_KEYS.find((s) => s.key === key) : void 0;
}
function systemKeyForLabel(label) {
  if (!label) return void 0;
  return SYSTEM_FIELD_KEYS.find((s) => s.labelPatterns.some((p) => p.test(label)));
}

export { ACTIVITY_STATUSES, ACTIVITY_STATUS_LABELS_RU, ACTIVITY_TYPES, ACTIVITY_TYPE_LABELS_RU, CONTENT_KINDS, CONTENT_KIND_LABELS_RU, DEFAULT_REMIND_DAYS, EVENT_LIFECYCLES, EVENT_SOURCES, EVENT_SOURCE_LABELS_RU, FORM_FIELD_KEY_MAX, FORM_FIELD_KEY_PATTERN, HEX_COLOR_RE, INTRANET_MODERATABLE_MODULES, INTRANET_MODULE_KEYS, INTRANET_MODULE_LABELS_RU, ISO_COUNTRY_CODES, LK_ADMIN_ROLE_CODE, LK_ADMIN_ROLE_REF, PROJECT_COLORS, REGISTRATION_STATUSES, REGISTRATION_STATUS_LABELS_RU, REMIND_DAYS_OPTIONS, ROLE_LK_ADMIN, ROLE_LK_USER, RU_REGIONS, SERVICE_CATEGORIES, SERVICE_CATEGORY_LABELS_RU, SERVICE_VISIBILITIES, SERVICE_VISIBILITY_LABELS_RU, SYSTEM_FIELD_KEYS, WORK_REGION_ABROAD, countryOptions, countryTitle, filePreview, formatRoleRef, isPersonalProjectColor, parseRoleName, parseRoleRef, regionTitle, roleName, systemFieldKey, systemKeyForLabel, workRegionOptions };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map